import React from 'react'
import Button from '../../atoms/button/button'
import './sectionKnowMore.scss'
import towelIlustration from '../../../assets/images/more/toalla.png'
import useGetInscription from '../../../utils/hooks/useGetInscription'
import { navigate } from 'gatsby'
import pushEventDataLayer from "../../../utils/pushEventDataLayer";

const SectionKnowMore = () => {
  const [isAmbassador, isLoading] = useGetInscription()

  return (
    <section className="f-know-more-attributes">
      <div className="f-know-more-attributes__wrapper">
        <div className="f-know-more-attributes__header mobile">
          Conoce sus atributos
        </div>
        <div className="f-know-more-attributes__body mobile">
          <p>
            Descubre todos los detalles de nuestras nuevas Toallas Día y
            conviértete en una Embajadora de nuestra tecnología
          </p>
        </div>
        <figure className="f-know-more-attributes__figure">
          <img
            className="f-know-more-attributes__image"
            src={towelIlustration}
          />
        </figure>
        <aside className="f-know-more-attributes__aside">
          <div className="f-know-more-attributes__header desktop">
            Conoce sus atributos
          </div>
          <div className="f-know-more-attributes__body desktop">
            <p>
              Descubre todos los detalles de nuestras nuevas Toallas para el día
              y conviértete en una Embajadora de la nueva Tecnología Cur-V.
            </p>
          </div>
          {/* {!isAmbassador && (
            <footer className="f-know-more-attributes__footer">
              <Button
                onClick={() => {
                  pushEventDataLayer({
                    "event": 'Interacciones - Inscripción',
                    'category':'embajadoras-curv',
                    "action": 'click',
                    "label": 'INSCRÍBETE AQUÍ',
                    "location": "nosotras.com/embajadoras"

                  })
                  navigate('/inscripcion')
                }}
                title={'INSCRÍBETE AQUÍ'}
                className="blue"
              ></Button>
            </footer>
          )} */}
        </aside>
      </div>
    </section>
  )
}

export default SectionKnowMore
